import classes from './ReviewsTab.module.scss';
import i18n from '../../../../../utils/i18n';
import { useState, useEffect } from 'react';
import { Divider, Pagination, Rating, Snackbar, Alert } from '@mui/material';
import CustomButton from '../../../../components/CustomButton';
import AttFlexibility from '../../../../components/AttFlexibility';
import AttPrecision from '../../../../components/AttPrecision';
import AttPricevalue from '../../../../components/AttPriceValue';
import AttIndustryExperience from '../../../../components/AttIndustryExperience';
import AttIndustryProfessionalism from '../../../../components/AttProfessionalism';
import StarBlue from '../../../../assets/DlpStarBlue.svg';
import NotVerifiedYet from '../../../../assets/DlpNotVerifiedYet.svg';

import axios from '../../../../../utils/axiosCompanyProxy';

const ReviewsTab = ({ providerData }) => {
	const id = providerData.providerID;
	const [reviews, setReviews] = useState([]);
	const [averages, setAverages] = useState({});
	const [linkCopied, setLinkCopied] = useState(false);

	const [currentPage, setCurrentPage] = useState(1);
	const reviewsPerPage = 6;
	const indexOfLastReview = currentPage * reviewsPerPage;
	const indexOfFirstReview = indexOfLastReview - reviewsPerPage;
	const currentReviews = reviews.slice(indexOfFirstReview, indexOfLastReview);
	const totalPages = Math.ceil(reviews.length / reviewsPerPage);

	const handlePageChange = (event, value) => {
		setCurrentPage(value);
	};

	const calculateAverageRating = (review) => {
		const {
			flexibility,
			industryexperience,
			precision,
			pricevalue,
			professionalism,
		} = review;
		const total =
			flexibility +
			industryexperience +
			precision +
			pricevalue +
			professionalism;
		return Number((total / 5).toFixed(1));
	};

	const pickAttributes = (reviews) => {
		if (reviews.length === 0) return 0;

		const totalFlexibility = reviews.reduce(
			(total, review) => total + review.flexibility,
			0
		);
		const averageFlexibility = (totalFlexibility / reviews.length).toFixed(1);

		const totalIndustryexperience = reviews.reduce(
			(total, review) => total + review.industryexperience,
			0
		);
		const averageIndustryexperience = (
			totalIndustryexperience / reviews.length
		).toFixed(1);

		const totalPrecision = reviews.reduce(
			(total, review) => total + review.precision,
			0
		);
		const averagePrecision = (totalPrecision / reviews.length).toFixed(1);

		const totalPricevalue = reviews.reduce(
			(total, review) => total + review.pricevalue,
			0
		);
		const averagePricevalue = (totalPricevalue / reviews.length).toFixed(1);

		const totalProfessionalism = reviews.reduce(
			(total, review) => total + review.professionalism,
			0
		);
		const averageProfessionalism = (
			totalProfessionalism / reviews.length
		).toFixed(1);

		const numberOfAttributes = 5;

		const totalAverage = (
			(parseFloat(averageFlexibility) +
				parseFloat(averageIndustryexperience) +
				parseFloat(averagePrecision) +
				parseFloat(averagePricevalue) +
				parseFloat(averageProfessionalism)) /
			numberOfAttributes
		).toFixed(1);

		return {
			averageFlexibility: parseFloat(averageFlexibility),
			averageIndustryexperience: parseFloat(averageIndustryexperience),
			averagePrecision: parseFloat(averagePrecision),
			averagePricevalue: parseFloat(averagePricevalue),
			averageProfessionalism: parseFloat(averageProfessionalism),
			totalAverage: parseFloat(totalAverage),
		};
	};

	useEffect(() => {
		const fetchProviderReviews = (id) => {
			try {
				let data = JSON.stringify({ providerID: id });
				axios
					.post('/api/review/id', data, {
						headers: {
							'Content-Type': 'application/json',
						},
					})
					.then((response) => {
						//console.log('PROVIDER REVIEWS', response);
						setReviews(response.data.review);
						setAverages(pickAttributes(response.data.review));
					})
					.catch((error) => {
						console.log('AXIOS ERROR: ', error.response.data);
					});
			} catch (error) {
				console.error('Error fetching provider reviews:', error);
			}
		};
		fetchProviderReviews(id);
	}, [id]);
	console.log(reviews, 'reviews');
	return (
		<>
			<div className={classes.paragraph}>
				<div className={classes.leftColumn}>
					<div className={classes.profileTitle}>
						{i18n.t('providerdashboard.revtitle1')}
					</div>
				</div>

				<div className={classes.rightColumn}>
					<div className={classes.profileTitle}>
						{i18n.t('providerdashboard.revtext1')}
					</div>
					<label
						className={classes.introductionLabel}
						style={{ marginTop: '12px' }}>
						{i18n.t('providerdashboard.revtext2')}
						<span className={classes.blueText}>
							{i18n.t('providerdashboard.revtext3')}
						</span>
						{i18n.t('providerdashboard.revtext4')}
						<span className={classes.blueText}>
							{i18n.t('providerdashboard.revtext5')}
						</span>
						{i18n.t('providerdashboard.revtext6')}
					</label>
					<label
						className={classes.introductionLabel}
						style={{ marginTop: '12px' }}>
						{i18n.t('providerdashboard.revtext7')}
						<span className={classes.blueText}>
							{i18n.t('providerdashboard.revtext8')}
						</span>
						{i18n.t('providerdashboard.revtext9')}
					</label>
					<label
						className={classes.introductionLabel}
						style={{ marginTop: '12px' }}>
						{i18n.t('providerdashboard.revtext10')}
					</label>
					<label
						className={classes.introductionLabel}
						style={{ marginTop: '12px' }}>
						{i18n.t('providerdashboard.revtext11')}
					</label>
					{/* <label className={classes.profileTitle} style={{ marginTop: '12px' }}>
						{i18n.t('providerdashboard.revtext12')}
					</label> */}
					<div style={{ marginTop: '12px', display: 'flex', gap: '12px' }}>
						<CustomButton
							buttonName={i18n.t('providerdashboard.revtitle3')}
							onClick={() =>
								window.open(
									'https://t40tz85n2uw.typeform.com/chestionarconta',
									'_blank'
								)
							}
							buttonColor="#1c32f3"
							hoverColor="#0036cc"
							titleColor="#ffffff"
							titleHoverColor="#e0e0e0"
							width="auto"
							height="44px"
							padding="12px"
						/>
						<CustomButton
							buttonName={i18n.t('general.copyLink')}
							onClick={() => {
								navigator.clipboard.writeText(
									'https://t40tz85n2uw.typeform.com/chestionarconta'
								);
								setLinkCopied(true);
							}}
							buttonColor="#ffffff"
							hoverColor="#f5f5f5"
							titleColor="#1c32f3"
							titleHoverColor="#0036cc"
							width="auto"
							height="44px"
							padding="12px"
							style={{ border: '1px solid #1c32f3' }}
						/>
					</div>
					<Snackbar
						open={linkCopied}
						autoHideDuration={3000}
						onClose={() => setLinkCopied(false)}
						anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
						<Alert
							onClose={() => setLinkCopied(false)}
							severity="success"
							sx={{ width: '100%' }}>
							{i18n.t('general.linkCopied')}
						</Alert>
					</Snackbar>
				</div>
			</div>

			<Divider sx={{ margin: '12px 0' }} />

			<div className={classes.paragraph}>
				<div className={classes.leftColumn}>
					<div className={classes.profileTitle}>
						{i18n.t('providerdashboard.revtitle4')}
					</div>
					{reviews.length > 0 ? (
						<>
							<div className={classes.dlpAttributesContainer}>
								<AttFlexibility inputValue={averages.averageFlexibility} />
								<AttPrecision inputValue={averages.averagePrecision} />
								<AttPricevalue inputValue={averages.averagePricevalue} />
								<AttIndustryExperience
									inputValue={averages.averageIndustryexperience}
								/>
								<AttIndustryProfessionalism
									inputValue={averages.averageProfessionalism}
								/>
							</div>
						</>
					) : (
						<>
							<div className={classes.dlpNotVerifiedYetConatiner}>
								<img
									src={NotVerifiedYet}
									alt="Not Verified Yet"
									className={classes.dlpNotVerifiedYet}
								/>
								<div className={classes.dlpNotVerifiedYetText}>
									{i18n.t('providerprofile.notverifiedyet')}
								</div>
							</div>
						</>
					)}
				</div>

				<div className={classes.rightColumn}>
					<>
						<div className={classes.dlpAttributesContainer}>
							{reviews.length === 0 ? (
								<div className={classes.dlpProviderReviewsNull}>
									<img
										src={StarBlue}
										alt={i18n.t('general.starBlue')}
										className={classes.dlpStarBlue}
									/>
									<div className={classes.dlpSumOfReviews}>
										{reviews.length}
									</div>
									{i18n.t('general.review')}
								</div>
							) : (
								<div className={classes.dlpProviderReviews}>
									<img
										src={StarBlue}
										alt={i18n.t('general.starBlue')}
										className={classes.dlpStarBlue}
									/>
									<div className={classes.dlpSumOfReviews}>
										{reviews.length}
									</div>
									{i18n.t('general.review')}
								</div>
							)}
						</div>
					</>
					<div className={classes.dlpProviderReviewsContainer}>
						{currentReviews.map((review, index) => (
							<div key={index} className={classes.dlpProviderReviewCard}>
								<div className={classes.dlpProviderReviewHeader}>
									<div className={classes.dlpProviderReviewReviewer}>
										{review.reviewer}
									</div>
									<div className={classes.dlpProviderReviewDate}>
										{review.date}
									</div>
								</div>
								<div className={classes.dlpProviderReviewAvgContainer}>
									<div className={classes.dlpProviderReviewAvgStars}>
										<Rating
											value={calculateAverageRating(review)}
											precision={0.1}
											readOnly
											sx={{ fontSize: '1rem' }}
										/>
									</div>
									<div className={classes.dlpProviderReviewAvgNumber}>
										{calculateAverageRating(review)}
									</div>
								</div>
								<div className={classes.dlpProviderReviewText}>
									{review.review}
								</div>
							</div>
						))}
					</div>
					{totalPages > 0 && (
						<Pagination
							count={totalPages}
							page={currentPage}
							onClick={(e) => e.stopPropagation()}
							onChange={handlePageChange}
							color="primary"
							className={classes.dlpReviewsPaginator}
							shape="rounded"
							sx={{
								'& .MuiPaginationItem-root': {
									color: '#4D5BEC',
									border: '1px solid #E3E5E9',
									borderRadius: '6px',
								},
								'& .MuiPaginationItem-root.Mui-selected': {
									backgroundColor: '#4D5BEC',
									color: '#ffffff',
									border: '1px solid #E3E5E9',
									borderRadius: '6px',
								},
								'& .MuiPaginationItem-root.Mui-selected:hover': {
									backgroundColor: '#4D5BEC',
									color: '#ffffff',
									border: '1px solid #E3E5E9',
									borderRadius: '6px',
								},
							}}
						/>
					)}
				</div>
			</div>
		</>
	);
};

export default ReviewsTab;
